import styled from '@emotion/styled'
import tokens from '@lacedltd/design-tokens'

export const PremiumCartDeliveryWrap = styled.div({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  gap: tokens.spacing[3]
})
